import React from 'react';

import PropTypes from 'prop-types';

const CarouselControls = ({
    currentIndex,
    items,
    onSelect,
    showArrows = true,
    className = '',
}) => {
    return (
        <div className={`controls ${className} d-flex align-items-center justify-content-between`}>
            <div className="arrow-left">
                {showArrows && (
                    <button
                        type="button"
                        className="slide-left"
                        title="Go left"
                        onClick={() => onSelect(currentIndex - 1)}
                    />
                )}
            </div>
            <div className="bullets-container text-center">
                {
                    items.map((item, idx) => {
                        let title = item.title || item.props?.title;
                        title = title === undefined ? `Go to ${idx + 1}` : `Go to ${title}`;

                        return (
                            <button
                                key={item.id || item.props?.id || `carousel-control-${idx}`}
                                type="button"
                                className={`slide${idx === currentIndex ? ' current' : ''}`}
                                title={title}
                                aria-label={title}
                                onClick={() => onSelect(idx)}
                            >
                                <span />
                            </button>
                        );
                    })
                }
            </div>
            <div className="arrow-right">
                {showArrows && (
                    <button
                        type="button"
                        className="slide-right"
                        title="Go right"
                        onClick={() => onSelect(currentIndex + 1)}
                    />
                )}
            </div>
        </div>
    );
};

CarouselControls.propTypes = {
    currentIndex: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
    })).isRequired,
    onSelect: PropTypes.func.isRequired,
    showArrows: PropTypes.bool,
    className: PropTypes.string,
};

export default React.memo(CarouselControls);
